import { color } from '@ticketswap/solar'
import { Star } from '@ticketswap/solar/icons'
import statsMap from './statsMap'

const GOOGLE_REVIEW_LINK =
  'https://www.google.com/search?q=ticketswap&oq=ticketswap#lrd=0x47c609c0ebc39a5d:0x1753de789106d98b,3,,,'

function useStats({ t, starSize = 16 }) {
  const stars = Array(5)
    .fill()
    .map((_, i) => i + 1)
  const getStarsRating = rating =>
    stars.map(i => (
      <Star
        key={i}
        size={starSize}
        color={i <= rating.toFixed() ? color.sun : color.foregroundSubtle}
      />
    ))

  return {
    userCount: statsMap.USER_COUNT,
    userCountInMillions: parseInt(statsMap.USER_COUNT.toString()[0]),
    jobOffers: statsMap.JOB_OFFERS,
    countriesCount: statsMap.COUNTRIES_COUNT,
    trustPilotReviews: statsMap.TRUSTPILOT_REVIEWS,
    appStoreStars: getStarsRating(statsMap.APP_STORE_RATING),
    playStoreStars: getStarsRating(statsMap.PLAY_STORE_RATING),
    playStoreReviewsLabel: t('common:appStoreBadges.reviews', {
      score: statsMap.PLAY_STORE_RATING,
      countOfReviews: statsMap.PLAY_STORE_REVIEWS,
    }),
    appStoreReviewsLabel: t('common:appStoreBadges.reviews', {
      score: statsMap.APP_STORE_RATING,
      countOfReviews: statsMap.APP_STORE_REVIEWS,
    }),
    appStoreReviewsCount: statsMap.APP_STORE_REVIEWS,
    playStoreReviewsCount: statsMap.PLAY_STORE_REVIEWS,
    googleReviewsCount: statsMap.GOOGLE_REVIEWS,
    googleStars: getStarsRating(statsMap.GOOGLE_RATING),
    googleReviewLink: GOOGLE_REVIEW_LINK,
  }
}

export default useStats
